module.exports = __webpack_public_path__ + "static/media/logo_transparent.e3f1d567.png";